import { makeAutoObservable } from 'mobx';

/** id выпадающего каталога — для aria-controls у всех кнопок-триггеров */
export const CATALOG_MENU_ID = 'catalog-menu';

/** Открыт ли выпадающий каталог: им управляют шапка и главная, рисует widgets/catalog-dropdown */
class CatalogMenuStore {
  isOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  close = (): void => {
    this.isOpen = false;
  };
  toggle = (): void => {
    this.isOpen = !this.isOpen;
  };
}

export const catalogMenuStore = new CatalogMenuStore();
